import { withoutCents } from './without_cents';
import { divideBy100 } from '../../math/divide_by_100';

export const withCents = (
    value,
    currencyIsoCode,
    noHTML,
    currencySetupOverrides = {}
) => withoutCents(
    divideBy100(value),
    currencyIsoCode,
    noHTML,
    { ...currencySetupOverrides, ...{decimalDigits : 2} }
);
